import React from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

// База начисления программы для организаций: с продаж (включая продажи в долг) или только
// с полученных денег — оплаченной на месте части чека и оплат долга. У гостевой программы
// поля нет: гость всегда получает баллы с продажи
function AwardBasisField({ data, setData }) {
	const { t } = useTranslation()

	const awardBases = [
		{ 'id': 'sales', 'name': t('award_basis_sales') },
		{ 'id': 'payments', 'name': t('award_basis_payments') },
	]

	if (data.audience !== 'organizations') return null

	return (
		<div className="form-group">
			<label>{t('award_basis')}</label>
			<Select
				options={awardBases}
				value={awardBases.find(option => option.id === (data.award_basis ?? 'sales'))}
				onChange={(option) => setData({ ...data, 'award_basis': option.id })}
				placeholder=""
				getOptionLabel={(option) => option.name}
				getOptionValue={(option) => option.id}
			/>
			<small className="text-muted">
				{data.award_basis === 'payments' ? t('award_basis_payments_hint') : t('award_basis_sales_hint')}
			</small>
		</div>
	)
}

export default AwardBasisField
